import * as moment from 'moment';
import { Moment } from 'moment';

export class CertificateRecordCommand {
    formData: FormData;

    constructor(certificationId: string, issueDate: Moment, expirationDate: Moment, file?: File, notifyAboutExpiration?: boolean) {
        this.formData = new FormData();

        if (file) {
            this.formData.append('file', file, file.name);
        }

        if (notifyAboutExpiration !== undefined) {
            this.formData.append('notify_about_expiration', String(notifyAboutExpiration));
        }

        this.formData.append('certification[id]', certificationId);
        this.formData.append('issue_date', moment(issueDate).format());
        if (expirationDate) {
            this.formData.append('expiration_date', moment(expirationDate).format());
        }
    }
}
